import CookieBanner from "@/components/site/CookieBanner";
import Footer from "@/components/site/Footer";
import Header from "@/components/site/Header";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-mist-ink overflow-x-hidden font-sans">
      <Header />
      <main className="flex-1 overflow-x-hidden pt-[72px] xl:pt-[110px]">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
